import React from "react";
import dayjs from "dayjs";

const OrderDetailsMetaInfo = ({ data }) => {
  const statusHexColorMap = {
    // shipped: "#4f46e5",
    // returnRequest: "#fb923c",
    // pickup: "#06D6A0",
    // Cancelled: "#ef427c",
    // Awaiting: "#bc93e4",
    // processing: "#4f46e5",
    // exchangeRequest: "#fb923c",
    delivered: "#06D6A0",
    shipped: "#4f46e5",
    returnRequest: "#fb923c",
    returnConfirmed: "#06D6A0",
    pickup: "#06D6A0",
    pending: "#bc93e4",
    Cancelled: "#ef427c",
    Awaiting: "#bc93e4",
    processing: "#4f46e5",
    exchangeRequest: "#fb923c",
    exchangeConfirmed: "#06D6A0",
  };

  const statusDeliveryHexColorMap = {
    Awaiting: "#bc93e4",
    Processing: "#FFD166",
    "In Transit": "#fb923c",
    Delivered: "#06D6A0",
    Cancelled: "#ef427c",
  };

  return (
    <>
      <div
        className="grid grid-cols-2 gap-4 w-full"
        style={{
          "--statusColor": statusHexColorMap[data?.status],
          "--deliveryStatusColor": statusHexColorMap[data?.status],
        }}
      >
        <div className="space-y-0.5">
          <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">
            Invoice ID
          </div>
          <div className="text-sm 2xl:text-base font-medium !leading-none">
            {data?.invoiceNumber}
          </div>
        </div>
        <div className="space-y-0.5">
          <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">
            Date
          </div>
          <div className="text-sm 2xl:text-base font-medium !leading-none">
            {" "}
            {dayjs(data?.createdAt).format("D MMMM, YYYY")}
          </div>
        </div>
        <div className="space-y-0.5">
          <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">
            Status
          </div>
          <div
            className="text-sm 2xl:text-base font-semibold inline-block !leading-none"
            style={{ color: "var(--statusColor)" }}
          >
            {data?.status?.charAt(0).toUpperCase() + data?.status?.slice(1)}
          </div>
        </div>
        <div className="space-y-0.5">
          <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">
            Delivery Status
          </div>
          <div
            className="text-sm 2xl:text-base font-semibold inline-block !leading-none"
            style={{ color: "var(--statusColor)" }}
          >
            {data?.status?.charAt(0).toUpperCase() + data?.status?.slice(1)}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderDetailsMetaInfo;
